import React, { forwardRef, useEffect, useState, createRef } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation } from 'react-router-dom';

import ScrollTopButton from 'src/components/widgets/buttons/ScrollTopButton';

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: ({ gutterTop }) => (gutterTop ? theme.spacing(3) : 0)
  }
}));

const Page = forwardRef(
  (
    { children, title = '', className = null, gutterTop = true, ...rest },
    ref
  ) => {
    const classes = useStyles({ gutterTop });
    const [contentWrapper, setContentWrapper] = useState(undefined);
    const internalRef = createRef();
    const location = useLocation();

    useEffect(() => {
      setContentWrapper(ref ? ref.current : internalRef.current);
    }, [ref, internalRef]);

    useEffect(() => {
      if (contentWrapper) {
        contentWrapper.scrollTo(0, 0);
      }
    }, [location.pathname]);

    const scrollUpTop = () => {
      contentWrapper.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
      <Box
        ref={ref || internalRef}
        sx={{
          flex: '1 1 auto',
          height: '100%',
          overflow: 'auto',
          scrollBehavior: 'smooth'
        }}
      >
        <div {...rest} className={className || classes.page}>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          {children}
          <ScrollTopButton
            scrollUpTop={scrollUpTop}
            contentWrapper={contentWrapper}
          />
        </div>
      </Box>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  gutterTop: PropTypes.bool
};

export default Page;

export const BasePage = forwardRef(
  (
    { children, title = '', className = null, gutterTop = true, ...rest },
    ref
  ) => {
    const classes = useStyles({ gutterTop });
    const [contentWrapper, setContentWrapper] = useState(undefined);
    const internalRef = createRef();
    const location = useLocation();

    useEffect(() => {
      setContentWrapper(ref ? ref.current : internalRef.current);
    }, [ref, internalRef]);

    useEffect(() => {
      if (contentWrapper) {
        contentWrapper.scrollTo(0, 0);
      }
    }, [location.pathname]);

    return (
      <Box
        ref={ref || internalRef}
        sx={{
          flex: '1 1 auto',
          height: '100%',
          overflow: 'auto',
          scrollBehavior: 'smooth'
        }}
      >
        <div {...rest} className={className || classes.page}>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          {children}
        </div>
      </Box>
    );
  }
);

BasePage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  gutterTop: PropTypes.bool
};
